export default __webpack_public_path__ + "static/media/020-lottery.4cb3b274.svg";